import React from "react";
import { boxKey, boxLabel } from "./box_allocation.js";
import { LotIdentity } from "./lot_identity.jsx";

// One horse's box, chosen from a list (spec S6). Every choice is exactly one
// governed write through the shared allocation, as on the Boxes view: an empty
// box assigns, an occupied one swaps, and taking out assigns no box.
export function BoxChooser({ allocation, lot, onClose }) {
  const sheet = React.useRef(null);
  const { boxes, occupants, data } = allocation;
  const here = boxKey(lot.box);
  const usable = boxes.filter(box => !box.feedRoom && boxKey(box) !== here);
  const empty = usable.filter(box => !occupants.has(boxKey(box)));
  // A withdrawn horse may leave its box but never enter another, so a swap
  // that would send it to this horse's box is not offered; the swap Action
  // refuses it too (workflows/box_assignments.py).
  const taken = data?.canSwap === true
    ? usable.filter(box => occupants.has(boxKey(box)))
      .filter(box => !(occupants.get(boxKey(box)).withdrawn && lot.box))
    : [];
  React.useEffect(() => { sheet.current?.querySelector("button")?.focus(); }, []);
  const pick = (box, horse) => { onClose(); allocation.choose(box, horse); };
  return <div className="box-chooser-backdrop" onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
    <div ref={sheet} className="box-picker box-chooser" role="dialog" aria-label={`Choose a box for Lot ${lot.number}`}
      onKeyDown={event => { if (event.key === "Escape") { event.stopPropagation(); onClose(); } }}>
      <div className="box-picker-head">
        <LotIdentity lot={lot}/>
        <strong>{lot.box ? `In box ${boxLabel(lot.box)}. Which box should it be in?` : "Not in a box. Which box should it be in?"}</strong>
      </div>
      {empty.length > 0 && <p className="caption box-chooser-group">Empty boxes</p>}
      {empty.map(box => <button key={boxKey(box)} type="button" className="box-option" data-box-choice={boxKey(box)} onClick={() => pick(box, lot)}>
        <span>{boxLabel(box)}</span>
        <span className="box-option-location muted">Move here</span>
      </button>)}
      {taken.length > 0 && <p className="caption box-chooser-group">Your other horses' boxes</p>}
      {taken.map(box => {
        const other = occupants.get(boxKey(box));
        return <button key={boxKey(box)} type="button" className="box-option" data-box-choice={boxKey(box)} onClick={() => pick(box, lot)}>
          <span>{boxLabel(box)} · Lot {other.number}</span>
          <span className="box-option-location muted">Swap with Lot {other.number}</span>
        </button>;
      })}
      {lot.box && <button type="button" className="box-option" data-box-choice="out" onClick={() => pick(lot.box, null)}>
        Take Lot {lot.number} out of {boxLabel(lot.box)}
      </button>}
      {!empty.length && !taken.length && !lot.box && <p className="caption box-picker-empty">No box is free for this horse.</p>}
      <div className="box-picker-foot"><button type="button" className="btn sm" onClick={onClose}>Cancel</button></div>
    </div>
  </div>;
}
